import { IconButton, Typography } from "@suraasa/placebo-ui"
import { Chip, Menu, MenuItem } from "@suraasa/placebo-ui-legacy"
import { VideoBookmark } from "api/resources/learningItems/types"
import { MoreVert, Trash } from "iconoir-react"

import { getTimestampFromSeconds } from "./getTimestampFromSeconds"

type NoteProps = {
  note: VideoBookmark
  onClick: () => void
  onDelete: () => void
}

const Note = ({ onClick, note, onDelete }: NoteProps) => {
  return (
    <div className="flex gap-1  rounded-lg bg-primary-50 p-1.5">
      <button onClick={onClick} className="flex w-full items-center gap-1">
        <Chip label={getTimestampFromSeconds(note.timestamp)} />
        <Typography className="flex-1 whitespace-pre-wrap text-start">
          {note.comment}
        </Typography>
      </button>
      <Menu
        portal
        menuButton={
          <IconButton color="black">
            <MoreVert />
          </IconButton>
        }
      >
        <MenuItem
          startAdornment={<Trash />}
          color="critical"
          onClick={onDelete}
        >
          Delete
        </MenuItem>
      </Menu>
    </div>
  )
}

interface Props {
  notes: VideoBookmark[]
  onDelete: (id: string) => void
  gotoTimeStamp: (time: number) => void
}

const Notes = ({ notes, onDelete, gotoTimeStamp }: Props) => {
  return (
    <div className="flex flex-col gap-1">
      {notes?.length === 0 ? (
        <Typography variant="body" className="text-center text-onSurface-500">
          Click on &quot;Add note&quot; to create notes for this video.
        </Typography>
      ) : (
        notes
          .sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1))
          .map(i => (
            <Note
              note={i}
              key={i.uuid}
              onClick={() => gotoTimeStamp(i.timestamp)}
              onDelete={() => onDelete(i.uuid)}
            />
          ))
      )}
    </div>
  )
}

export default Notes
